import { Button, Form, InputNumber } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchSettings, saveSettings } from '../../../store/slices/settingsSlice';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
};

function PriceSettings({ onSwitchTab, tabProps = {} }) {
  const settings = useSelector(state => state.settingsSlice.settings);
  const loading = useSelector(state => state.settingsSlice.loading);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    loadValues();
  }, [settings]);

  useEffect(() => {
    dispatch(fetchSettings());
  }, [])

  const loadValues = () => {
    form.setFieldsValue(settings);
  }

  const savePriceSettings = (data) => {
      dispatch(saveSettings({ settingsData: data }));
  }

    return (
        <div>
          <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg w-fit text-xl '>Price Settings</div>
          <Form
                form={form}
                layout='verticle'
                {...formItemLayout}
                style={{
                    maxWidth: 600,
                    margin: 'auto'
                }}
                onFinish={savePriceSettings}
                disabled={loading.fetching}
            >
                <Form.Item
                    label="Default Shipping Fee"
                    name="defaultShippingFee"
                    rules={[
                        {
                            required: true,
                            message: 'Enter ',
                        },
                    ]}
                >
                    <InputNumber placeholder='Amount' />
                </Form.Item>
                <Form.Item
                    label="Registered Post With Tracking"
                    name="RWT"
                    rules={[
                        {
                            required: true,
                            message: 'Enter ',
                        },
                    ]}
                >
                    <InputNumber placeholder='Amount' />
                </Form.Item>
                <Form.Item
                    label="Un Registered Post Without Tracking"
                    name="UREG"
                    rules={[
                        {
                            required: true,
                            message: 'Enter ',
                        },
                    ]}
                >
                    <InputNumber placeholder='Amount' />
                </Form.Item>
                <Form.Item wrapperCol={{sm: {offset: 20, span: 6}, xs: {offset: 12, span: 14}}}>
                  <div className='flex justify-between'>
                      <div className='flex'>
                        <Button danger type='text' htmlType='reset'>Clear</Button>
                        <Button type='primary' htmlType='submit'>Save</Button>
                      </div>
                  </div>
                </Form.Item>
            </Form>
        </div>
    )
}

export default PriceSettings